import { AuthCheckerApi } from "@/api/AuthCheckerApi";

export class AuthCheckerService {

  /**
   * 添付ファイルの操作権限をチェックします
   * @returns 
   */
  public async tenpuFileControl(userId: number): Promise<boolean> {
    const api = new AuthCheckerApi()
    try {
      await api.tenpuFileControl(userId)
      return true
    } catch (e: any) {
      // MEMO: 基本的に失敗することはない
      return false
    }
  }
}